import { FormOrientationContext } from 'components/common-form/contexts/FormOrientationContext';
import { RemovableListItemFormGroup } from 'components/shared/FormGroup/RemovableListItemFormGroup';
import { FC, useContext } from 'react';

import { BarFormGroup } from './BarFormGroup';
import { GridFormGroup } from './GridFormGroup';
import { HorizontalFormGroup } from './HorizontalFormGroup';
import type { DefaultOrientationFormGroupProps } from './model';
import { VerticalFormGroup } from './VerticalFormGroup';

export const BlockOrientationFormGroup: FC<DefaultOrientationFormGroupProps> = ({
  children,
  labelSize,
  tooltipKey,
  minWidth,
  maxWidth,
  tooltipLocation,
  ...other
}) => {
  const orientation = useContext(FormOrientationContext);
  switch (orientation) {
    case 'horizontal':
      return (
        <HorizontalFormGroup labelSize={labelSize} {...other}>
          {children}
        </HorizontalFormGroup>
      );
    case 'grid':
      return (
        <GridFormGroup minWidth={minWidth} maxWidth={maxWidth} tooltipLocation={tooltipLocation} {...other}>
          {children}
        </GridFormGroup>
      );
    case 'bar':
      return <BarFormGroup {...other}>{children}</BarFormGroup>;
    case 'removableListItem':
      return <RemovableListItemFormGroup {...other}>{children}</RemovableListItemFormGroup>;
    case 'vertical':
    default:
      return (
        <VerticalFormGroup tooltipKey={tooltipKey} {...other}>
          {children}
        </VerticalFormGroup>
      );
  }
};

BlockOrientationFormGroup.displayName = 'BlockOrientationFormGroup';
